<template>
  <shop-default-layout is-aw-spring :spring-desktop-size="100">
    <slot />
  </shop-default-layout>
</template>

<script>

  import ShopDefaultLayout from '~~/shop/app/layouts/default.vue';

  export default {
    name: 'FullWidthVue',
    components: { ShopDefaultLayout },
  };
</script>
